import React, { lazy, Suspense, memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import dayjs from "dayjs";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  // 언어 변경 시 dayjs 로케일도 업데이트
  useEffect(() => {
    // 현재 언어에 맞는 dayjs 로케일 설정
    let localeToSet = 'en';
    switch(locale) {
      case 'ko':
        localeToSet = 'ko';
        break;
      case 'ja':
        localeToSet = 'ja';
        break;
      case 'zh-Hans':
        localeToSet = 'zh-cn';
        break;
      case 'th':
        localeToSet = 'th';
        break;
      default:
        localeToSet = 'en';
        break;
    }
    
    // 전역 dayjs 로케일 설정
    dayjs.locale(localeToSet);
    
    // 모든 새로운 dayjs 인스턴스에 대해 기본 로케일 설정
    const originalDayjs = dayjs;
    window.dayjs = (date) => {
      return originalDayjs(date).locale(localeToSet);
    };
    Object.setPrototypeOf(window.dayjs, originalDayjs);
    Object.assign(window.dayjs, originalDayjs);
    
  }, [locale]);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
